module.exports = __webpack_public_path__ + "img/25.13ae378e.jpg";